import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const ChatbotNavigationHeader = ({ user = null }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const handleUserMenuToggle = () => {
    setShowUserMenu(!showUserMenu);
  };

  const handleHelpToggle = () => {
    setShowHelp(!showHelp);
  };

  const handleLogout = () => {
    // Logout functionality
    console.log('Logout clicked');
    setShowUserMenu(false);
  };

  const handleProfile = () => {
    // Profile functionality
    console.log('Profile clicked');
    setShowUserMenu(false);
  };

  return (
    <>
      <header className="fixed top-0 right-0 left-0 z-[150] bg-background border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* User Menu and Help (Left side in RTL) */}
            <div className="flex items-center space-x-reverse space-x-4">
              {/* Help Button */}
              <button
                onClick={handleHelpToggle}
                className="inline-flex items-center px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded-md">
                <Icon name="HelpCircle" size={20} className="ml-2" />
                راهنما
              </button>

              {/* User Menu */}
              {user && (
                <div className="relative">
                  <button
                    onClick={handleUserMenuToggle}
                    className="flex items-center space-x-reverse space-x-2 px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-smooth focus-ring rounded-md">
                    <Icon name="ChevronDown" size={16} className="ml-1" />
                    <span>{user?.name || 'کاربر'}</span>
                    <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                      <Icon name="User" size={16} color="white" />
                    </div>
                  </button>

                  {/* User Dropdown Menu */}
                  {showUserMenu && (
                    <div className="absolute left-0 mt-2 w-48 bg-popover border border-border rounded-md shadow-moderate z-50">
                      <div className="py-1">
                        <button
                          onClick={handleProfile}
                          className="flex items-center w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth">
                          <Icon name="User" size={16} className="ml-3" />
                          پروفایل کاربری
                        </button>
                        <button
                          onClick={handleLogout}
                          className="flex items-center w-full px-4 py-2 text-sm text-destructive hover:bg-muted transition-smooth">
                          <Icon name="LogOut" size={16} className="ml-3" />
                          خروج از حساب
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Logo (Right side in RTL) */}
            <Link
              to="/legal-consultation-chatbot"
              className="flex items-center space-x-reverse space-x-3 focus-ring rounded-lg p-2">
              <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                <Icon name="Scale" size={20} color="white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-semibold text-foreground">
                  ایران‌داد
                </span>
                <span className="text-xs text-muted-foreground -mt-1">
                  IranDaad
                </span>
              </div>
            </Link>
          </div>
        </div>
      </header>
      {/* Help Overlay */}
      {showHelp && (
        <div className="fixed inset-0 z-[200] bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="bg-popover rounded-lg shadow-moderate max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-popover-foreground">
                راهنمای استفاده
              </h3>
              <button
                onClick={handleHelpToggle}
                className="text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded-md p-1">
                <Icon name="X" size={20} />
              </button>
            </div>
            <div className="space-y-3 text-sm text-popover-foreground">
              <p>• سوال خود را به زبان فارسی بپرسید</p>
              <p>• از جملات واضح و مشخص استفاده کنید</p>
              <p>• برای دریافت پاسخ بهتر، جزئیات بیشتری ارائه دهید</p>
              <p>• در صورت نیاز به مشاوره تخصصی، با وکیل تماس بگیرید</p>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={handleHelpToggle}
                className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth focus-ring">
                متوجه شدم
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Click outside to close menus */}
      {(showUserMenu || showHelp) && (
        <div
          className="fixed inset-0 z-[140]"
          onClick={() => {
            setShowUserMenu(false);
            setShowHelp(false);
          }}
        />
      )}
    </>
  );
};

export default ChatbotNavigationHeader;
